// extracted by mini-css-extract-plugin
export default {"content":"Consultation_content__wRo1h","info":"Consultation_info__rQXjx","info__list":"Consultation_info__list__Cuijs","image":"Consultation_image__ZPL0P"};